import React from "react";
import { appHistory } from "@/router/history";
import { withAuthData } from "./context/AuthContext";

interface UnauthenticatedWrappedProps {
  userLoggedIn?: boolean;
  adminToken?: string | boolean | null;
  [key: string]: unknown;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function UnauthenticatedComponent(
  ComposedComponent: React.ComponentType<any>
): React.ComponentType<Record<string, unknown>> {
  function UnauthenticatedWrapper(props: UnauthenticatedWrappedProps) {
    React.useEffect(() => {
      if (props.userLoggedIn) {
        appHistory.push(BASE_PATH + "/");
      } else if (props.adminToken) {
        appHistory.push(BASE_PATH + "/borrow_customer");
      }
    }, [props.userLoggedIn, props.adminToken]);

    if (!props.userLoggedIn && !props.adminToken) {
      return <ComposedComponent {...(props as Record<string, unknown>)} />;
    }
    return null;
  }

  return withAuthData(UnauthenticatedWrapper) as unknown as React.ComponentType<
    Record<string, unknown>
  >;
}
